import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLoginMutation } from '../store/metricsApi';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  
  const [login, { isLoading: loginLoading }] = useLoginMutation();

  useEffect(() => {
    // Check if token exists on app load
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      setToken(storedToken);
      setIsAuthenticated(true);
      // You could also validate the token here
    }
  }, []);

  const loginUser = async (credentials) => {
    try {
      const result = await login(credentials).unwrap();
      
      if (result.success && result.data && result.data.token) {
        const userData = {
          token: result.data.token,
          usertype: result.data.usertype,
          // Add other user data as needed
        };
        
        localStorage.setItem('authToken', result.data.token);
        localStorage.setItem('userType', result.data.usertype);
        
        setToken(result.data.token);
        setUser(userData);
        setIsAuthenticated(true);
        
        return { success: true };
      }
    } catch (error) {
      console.error('Login failed:', error);
      return { 
        success: false, 
        error: error.data?.message || 'Login failed. Please try again.' 
      };
    }
  };

  const logoutUser = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userType');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  const value = {
    user,
    token,
    isAuthenticated,
    loginUser,
    logoutUser,
    loginLoading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
